import React from 'react';

const PermissionIcon = (props) => (
  <svg role='presentation' width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <path d='M16,5.20891571 L16.388421,5.49736252 C18.7552235,7.2549829 21.3928657,8.61224432 24.1960592,9.51639467 L24.758874,9.69116762 L24.758874,10.1887652 C24.758874,16.8057958 21.6284686,23.0238076 16.3337305,26.9655384 L16,27.2089157 C10.5033236,23.2827183 7.24112596,16.9436506 7.24112596,10.1887652 L7.24112596,9.69116762 C10.2387114,8.79126536 13.0584928,7.38075484 15.5763122,5.52174229 L16,5.20891571 Z M15.998,7.675 L15.7357297,7.85639157 C13.8231616,9.14497041 11.7652494,10.2020351 9.60530514,11.00592 L9.265,11.127 L9.27851331,11.3787016 C9.37828073,12.9640896 9.67632983,14.5155909 10.1559543,16.000742 L16,16 L16,24.679 L16.0714544,24.620792 C18.78376,22.3231156 20.7697689,19.3274274 21.8441377,16.00033 L16,16 L15.998,7.675 Z' />
    </g>
  </svg>
);

export default PermissionIcon;
